import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { reduxForm } from 'redux-form';
import { semanticColors } from '../../Globals/styles';
import { isStringValid } from '../../Util/stringValidator';
import $ from 'jquery';
import RootActivity from './rootActivity';


class WizardStepTwo extends Component {
  componentDidMount = () => {
    if (this.props.isEdit) {
      this.props.setRowShouldUpdate(0, 0, 0);
    }
    $('form').on('keyup keypress', function (e) {
      var keyCode = e.keyCode || e.which;
      // eslint-disable-next-line
      if (keyCode == 13) {
        e.preventDefault();
        return false;
      }
    });
  };
  componentWillMount = () => {
    // eslint-disable-next-line
    if (this.props.fields.rootActivities.length == 0) {
      this.props.fields.rootActivities.addField();
    }
  };
  handleSubmitClick = () => {
    //set update to 0 0 0 for all components to update
    this.props.setRowShouldUpdate(0, 0, 0);
    var errors = $(".error")
    if (errors.length) {
      $('html,body').animate({
        scrollTop: $(errors[0]).offset().top - 200
      }, 300);
    }
  };
  addRoot = () => {
    //set shouldrow update to the new row added, so children gets rendered
    this.props.setRowShouldUpdate(this.props.fields.rootActivities.length + 1)
    this.props.fields.rootActivities.addField();
  };
  render() {
    const {
      fields: {
        rootActivities
      },
      handleSubmit,
      previousPage,
      setRowShouldUpdate,
      rowShouldUpdate,
      isEdit
      } = this.props;

    //total sum
    var totalSum = 0;

    var rootActivityNodes = rootActivities.map((rootActivity, i) => {
      let indexKey = i + 1;
      //var for rootSum
      let rootSum = 0;

      rootActivity.seconds.forEach((second) => {
        //if any values on the third it should not render self
        let shoudRootSumAdd = true;
        second.thirds.forEach((third) => {
          //if any values on the third it should calculate thirds sum
          if (
            isStringValid(third.name.value) ||
            isStringValid(third.unit.value) ||
            third.amount.value ||
            // eslint-disable-next-line
            third.amount.value == 0 ||
            third.hoursPerUnit.value ||
            // eslint-disable-next-line
            third.hoursPerUnit.value == 0 ||
            third.sum.value ||
            // eslint-disable-next-line
            third.sum.value == 0) {
            //calculate total sum of thirds
            rootSum += third.sum.value;
            shoudRootSumAdd = false
          }

        });
        if (shoudRootSumAdd && second.sum.value)
          rootSum += second.sum.value
      });
      totalSum += rootSum;

      return (
        <RootActivity
          key={indexKey}
          rootActivity={rootActivity}
          indexKey={indexKey}
          rootActivityCount={rootActivities.length}
          rootSum={rootSum}
          styles={styles}
          setRowShouldUpdate={(secondKey, thirdKey) => setRowShouldUpdate(indexKey, secondKey, thirdKey)}
          rowShouldUpdate={rowShouldUpdate}
          // eslint-disable-next-line
          addNewField={indexKey == rootActivities.length ? this.addRoot : null}
          isEdit={isEdit}

        />)
    });
    return (
      <div>
        <form onSubmit={handleSubmit}>

          {rootActivityNodes}

          <div style={styles.totalSum}>Timer i alt {Math.round(totalSum * 100) / 100}</div>
          <div style={styles.submitButtonContainer}>
            <button
              onClick={this.handleSubmitClick}
              type="submit"
              style={styles.submitButton}
              className="btn btn-success"
            >{isEdit ? "Gem" : "Opret"}</button>
          </div>
        </form>
        <div style={styles.submitButtonContainer}>
          <button
            onClick={previousPage}
            type="submit"
            className="btn btn-primary"
            style={styles.backButton}>Tilbage</button>
        </div>
      </div>
    );
  }
}

var styles = {
  rootActivityContainer: {
    width: '100%',
    clear: 'both',
    marginTop: '20px',
    paddingBottom: '25px',
    borderBottom: '1px solid ' + semanticColors.mainBackground,
    marginLeft: '0',
    marginRight: '0'
  },
  activityContainer: {
    width: '100%',
    clear: 'both',
    marginLeft: '0',
    marginBottom: '5px'
  },
  rootRowName: {
    margin: '5px 0'
  },
  col: {
    padding: '0 0 0 12px'
  },
  headingsRow: {
    textAlign: 'right'
  },
  firstInRootRow: {
    textAlign: 'left',
    padding: '0 0 0 24px',
    position: 'relative',
  },
  firstInSecondRow: {
    padding: '0 0 0 48px',
    position: 'relative',
  },
  firstInThirdRow: {
    padding: '0 0 0 72px',
    position: 'relative',
  },
  inputField: {
    border: 'none',
    boxShadow: 'none',
    borderRadius: '2px',
    textAlign: 'right',
  },
  inputFieldName: {
    textAlign: 'left',
  },
  rootInputField: {
    backgroundColor: '#B8D9E5',
  },
  secondInputField: {
    backgroundColor: '#DAEBF1',
  },
  thirdInputField: {
    backgroundColor: '#ECF5F8',
  },
  indexKey: {
    position: 'absolute',
    left: '-29px',
    lineHeight: '34px',
    textAlign: 'right',
    width: '50px'
  },
  indexKeySecond: {
    left: '-4px',
  },
  indexKeyThird: {
    left: '20px',
  },
  totalSum: {
    marginTop: '25px',
    marginBottom: '20px',
    textAlign: 'right',
    fontWeight: '700'
  },
  backButton: {
    float: 'right',
    width: '175px',
    marginBottom: '30px'
  },
  submitButton: {
    float: 'right',
    width: '175px',
    marginLeft: '12px',
    marginBottom: '30px'
  },
  thirdsSum: {
    lineHeight: '34px',
    fontWeight: '700',
    float: 'right',
    paddingRight: '11px'
  },
  rootSum: {
    lineHeight: '34px',
    fontWeight: '700',
    float: 'right',
    paddingRight: '11px',
    marginTop: '5px'
  },
}

function validateActivities(data) {
  const errors = {
    rootActivities: []
  }
  var errorMessage = "Skal udfyldes";
  //loop through all the data root activities
  data.rootActivities.forEach((rootActivty, rootActivityIndex) => {
    //create an empty error object for each root
    errors.rootActivities.push({
      seconds: []
    });
    var doesRootActivityNeedName = false;
    //loop through all second activities in the root
    rootActivty.seconds.forEach((second, secondIndex) => {
      // add a second object to the list of seconds in the root
      errors.rootActivities[rootActivityIndex].seconds[secondIndex] = { thirds: [] }
      var doesSecondActivityNeedName = false;

      //loop through all the third activities in the second
      second.thirds.forEach((third, thirdIndex) => {
        // add a third object to the list of third in the second
        errors.rootActivities[rootActivityIndex].seconds[secondIndex].thirds[thirdIndex] = {};
        // eslint-disable-next-line
        if (isStringValid(third.name) || isStringValid(third.unit) || third.amount || third.amount == 0 || third.hoursPerUnit || third.hoursPerUnit == 0 || third.sum || third.sum == 0) {
          doesSecondActivityNeedName = true;
          if (!isStringValid(third.name)) errors.rootActivities[rootActivityIndex].seconds[secondIndex].thirds[thirdIndex].name = errorMessage
          if (!isStringValid(third.unit)) errors.rootActivities[rootActivityIndex].seconds[secondIndex].thirds[thirdIndex].unit = errorMessage
          if (!third.amount && third.amount !== 0) errors.rootActivities[rootActivityIndex].seconds[secondIndex].thirds[thirdIndex].amount = errorMessage
          if (!third.hoursPerUnit && third.hoursPerUnit !== 0) errors.rootActivities[rootActivityIndex].seconds[secondIndex].thirds[thirdIndex].hoursPerUnit = errorMessage
          if (!third.sum && third.sum !== 0) errors.rootActivities[rootActivityIndex].seconds[secondIndex].thirds[thirdIndex].sum = errorMessage
        }
      });
      //if any of the fields is filled or have a zero in the number inputs
      // eslint-disable-next-line
      if (isStringValid(second.name) || isStringValid(second.unit) || second.amount || second.amount == 0 || second.hoursPerUnit || second.hoursPerUnit == 0 || second.sum || second.sum == 0) {
        doesRootActivityNeedName = true;
        //if there is value in the third activity dont fill all fields
        if (!doesSecondActivityNeedName) {
          //if some of second's fields is filled, everyone of them is required.
          if (!isStringValid(second.name)) errors.rootActivities[rootActivityIndex].seconds[secondIndex].name = errorMessage
          if (!isStringValid(second.unit)) errors.rootActivities[rootActivityIndex].seconds[secondIndex].unit = errorMessage
          if (!second.amount && second.amount !== 0) errors.rootActivities[rootActivityIndex].seconds[secondIndex].amount = errorMessage
          if (!second.hoursPerUnit && second.hoursPerUnit !== 0) errors.rootActivities[rootActivityIndex].seconds[secondIndex].hoursPerUnit = errorMessage
          if (!second.sum && second.sum !== 0) errors.rootActivities[rootActivityIndex].seconds[secondIndex].sum = errorMessage
        }

      }
      //if the second activity needs a name, means it has values in children and only needs a name
      if (doesSecondActivityNeedName) {
        if (!isStringValid(second.name)) {
          errors.rootActivities[rootActivityIndex].seconds[secondIndex].name = errorMessage
        }
      }


    })
    if (doesRootActivityNeedName) {
      if (!isStringValid(rootActivty.name)) {
        errors.rootActivities[rootActivityIndex].name = errorMessage;
      }
    }
  })
  return errors;
}

let WizardStepTwoForm = reduxForm(
  {
    form: 'createProjectWizard',
    fields: [
      'rootActivities[].name',
      'rootActivities[].seconds[].name',
      'rootActivities[].seconds[].unit',
      'rootActivities[].seconds[].amount',
      'rootActivities[].seconds[].hoursPerUnit',
      'rootActivities[].seconds[].sum',
      'rootActivities[].seconds[].thirds[].name',
      'rootActivities[].seconds[].thirds[].unit',
      'rootActivities[].seconds[].thirds[].amount',
      'rootActivities[].seconds[].thirds[].hoursPerUnit',
      'rootActivities[].seconds[].thirds[].sum'
    ],
    destroyOnUnmount: false,
    validate: validateActivities
  }
)(Radium(WizardStepTwo));

WizardStepTwo.propTypes = {
  fields: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  previousPage: PropTypes.func.isRequired,
  setRowShouldUpdate: PropTypes.func.isRequired,
  rowShouldUpdate: PropTypes.object.isRequired,
  isEdit: PropTypes.bool.isRequired
};

export default WizardStepTwoForm;



// WEBPACK FOOTER //
// ./src/App/Project/CreateProject/wizardStepTwo.jsx